import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { environment } from '.../../environments/environment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { AuthService } from '../../_services/index';
import 'rxjs/add/operator/map';
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { Observable, Subscription } from 'rxjs/Rx';

declare var $: any;
export const MY_FORMATS = {
	parse: {
		dateInput: 'LL'
	},
	display: {
		dateInput: 'LL',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY'
	}
};
declare var MarkerClusterer: any;
declare var $: any;
declare var google: any;

declare var firebase: any;

interface Marker {
	lat: number;
	lng: number;
	label?: string;
	draggable?: boolean;
}

@Component({
	selector: 'app-live-tracking',
	templateUrl: './live-tracking.component.html',
	styleUrls: [ './live-tracking.component.scss' ],
	providers: [
		{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [ MAT_DATE_LOCALE ] },
		{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
	]
})
export class LiveTrackingComponent {
	private subscription: Subscription;
	prjId: any;
	userId: any;
	showLoader: any;
	dataRangeModal: any;
	startDate: any;
	endDate: any;
	defaultStartDate: any;
	defaultEndDate: any;
	public map: any;
	public bounds: any;
	public saerch: any;
	public date = moment();
	authtoken: any;
	polygondData: any;
	uccData: any;
	uccDataLength: any;
	uccReport: Object;
	wardList: any;

	items = [];
    pageOfItems: Array<any>;
	vehiclesData: any;
	tempVehiclesData: any;
	totalRows: any;
	totalPages = 1;
	pageNo = 1;
	totalitems: any;
	from = 1;
	to=50;
	limitSize = [
        {id: 1, size: 10},
        {id: 1, size: 25},
        {id: 1, size: 50},
        {id: 2, size: 100},
        {id: 3, size: 150}
    ];
	limit = 50;
	vehid: any;
	searchedVeh: string;

	constructor(
		private http: HttpClient,
		private auth: AuthService,
		private loaderService: LoaderService,
		public datepipe: DatePipe
	) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
		this.authtoken = JSON.parse(localStorage.getItem('authData'));
		var firstDay = new Date();
		var lastDay = new Date();
		this.defaultStartDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.defaultEndDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.dataRangeModal = {
			beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() },
			endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() }
		};
	}

	// getDataWhenProjectChange = async () => {
    //     $('#loderImgTab').show();
    //     // this.loaderService.display(true);
        
    //     let d = await fetch(
    //         environment.apiUrl +
    //         'vehicles/getAllMongo?prjID=' +
    //         this.prjId +
    //         '&DEVICEDATE=' +
    //         moment(new Date()).format('YYYY-MM-DD'),
    //         {
    //             method: 'get',
    //             headers: {
    //                 Accept: 'application/json',
    //                 'Content-Type': 'application/json',
    //                 Authorization: this.authtoken.token
    //             }
    //         }
    //     );
    //     this.tempVehiclesData = await d.json();
    //     // console.log("Oh Dammit", this.tempVehiclesData);

    //     this.vehiclesData = this.tempVehiclesData
	// 	this.plotAllVehicles(this.vehiclesData)
    //     // this.loaderService.display(false);

    //     $('.background').hide();
    //     $('#loderImgTab').hide();
    //     $('#progress-bar').hide();
    // };

	getDataWhenProjectChange = async () => {
		$('#loderImgTab').show();
		this.loaderService.display(true);
		//this.renoveAllMarker();
		let polygon = await fetch(
			environment.apiUrl + 'vehicles/getVehicleLiveDetails?prjid=' + this.prjId + '&pageNo=' + this.pageNo + '&limit=' + this.limit + '&vehno=' + this.searchedVeh,
			{
				method: 'get',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization: this.authtoken.token
				}
			}
		);
		this.polygondData = await polygon.json();

		this.totalitems = this.polygondData[0].totalItems	

		 console.log('163',this.totalitems);
		 
		this.totalPages = parseInt((this.totalitems / this.limit).toFixed(0),10)


		console.log('168',	this.totalPages );
		
		if (this.totalPages < (this.totalitems / this.limit)) {
			this.totalPages = this.totalPages + 1
		}	
		this.clearFeature();
		this.map.data.addGeoJson(this.polygondData.geoJson);
		this.zoom(this.map, true);
		//this.setStyle(this);
		this.loaderService.display(false);

		$('.background').hide();
		$('#loderImgTab').hide();
		$('#progress-bar').hide();
	};

	plotAllVehicles(data) {
        var locations = [];
        var thisRef = this;
        var infoWindow = new google.maps.InfoWindow();
        var bounds = new google.maps.LatLngBounds();
        var icon;
        var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        
        var markers = [];
		var marker = null;
		this.clearFeature();
         var car =
            'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
        for (var i = 0; i < data.length; i++) {
            if (data[i].LAT && data[i].LONG) {
                var item = data[i];
                if (!item.ANGLE) {
                    var rotation = 0;
                } else {
                    rotation = item.ANGLE;
                }

                icon = {
                    path: car,
                    scale: 0.7,
                    strokeColor: 'black',
                    strokeWeight: 1,
                    fillOpacity: 1,
                    fillColor: '#4AA951',
                    offset: '1%',
                    rotation: rotation //<-- Car angle
                };

				marker = new google.maps.Marker({
					position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LONG) },
					icon: icon
				});

				// markers.push(marker);
				marker.setMap(this.map);
            }
        }
    }

	onChangePage(pageOfItems: Array<any>) {
        // update current page of items
        this.pageOfItems = pageOfItems;
    }

	searchVeh(event: Event) {
		this.searchedVeh = (event.target as HTMLInputElement).value;
		console.log(this.searchedVeh.length);
		
		if (this.searchedVeh.length == 4 || this.searchedVeh.length == 0) {
			this.getDataWhenProjectChange()
		}
	}

	clearFeature() {
		this.map.data.forEach((feature) => {
			this.map.data.remove(feature);
		});
	}

	/*
     process each lat long for fit bound
  */
	processPoints(this, geometry, callback, thisArg) {
		if (geometry instanceof google.maps.LatLng) {
			callback.call(thisArg, geometry);
		} else if (geometry instanceof google.maps.Data.Point) {
			callback.call(thisArg, geometry.get());
		} else {
			if (geometry) {
				geometry.getArray().forEach((g) => {
					this.processPoints(g, callback, thisArg);
				});
			}
		}
	}

	/*
   zoom into entity polygon
*/
	zoom(this, map, isZone) {
		this.bounds = new google.maps.LatLngBounds();
		this.map.data.forEach((feature) => {
			if (isZone) {
				this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
			} else {
				if (feature.getProperty('type') == 'route') {
					this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
				}
			}
		});
		map.fitBounds(this.bounds);
	}

	/* 
    zoom into particular Zone and Ward
*/
	zoomPolygon(this, map) {
		this.bounds = new google.maps.LatLngBounds();
		map.data.forEach((feature) => {
			this.processPoints(feature.getGeometry(), this.bounds.extend, this.bounds);
		});
		map.fitBounds(this.bounds);
	}

	getDriver(data){
		console.log(data);
		this.vehid = data
		$('#driverModal').modal('show');
	}

	openNav() {
		$('#mySidenav').css('width','250px')
		$('#main-content-area').css('margin-right','250px')
		$('.main-content-area').css('width','calc(100% - 250px)')
	}
	  
	closeNav() {
		$('#mySidenav').css('width','0px')
		$('#main-content-area').css('margin-right','0px')
		$('.main-content-area').css('width','100%')
	}
	  
	onPageChange(pageNo: number) {
		var from = 1
		var to = this.limit
		this.pageNo = pageNo
		this.getDataWhenProjectChange();
		if (pageNo != from) {
			to = pageNo * this.limit
			from = to - (this.limit - 1)
			this.to = to
			this.from = from
			console.log(from + '-' + to + ' of ' + this.totalitems+ ' items');	
		} else {
			this.from = from
			this.to = to
		}

		if (pageNo == this.totalPages) {
			this.to = this.totalitems
		}
	}

	selectSize(data){
		this.limit = data.size
		this.to = this.limit
		this.getDataWhenProjectChange();
	}
	
	ngOnInit() {
		this.prjId = this.auth.getAuthentication().projectId;
		this.userId = this.auth.getAuthentication().id;
		this.getDataWhenProjectChange();
		var infoWindow;
		var lastOpenedInfoWindow;
		this.items = Array(150).fill(0).map((x, i) => ({ id: (i + 1), name: `Item ${i + 1}`}));
		var thisRef = this;

		// this.subscription = Observable.interval(3000).subscribe((x) => {
        //     this.getDataWhenProjectChange();
        // });
		$('#loderImgTab').hide();

		this.map = new google.maps.Map(document.getElementById('map'), {
			zoom: 16,
			center: { lat: 28.47769599987369, lng: 77.06160699973178 }
		});

		infoWindow = new google.maps.InfoWindow();
		this.map.data.setStyle(function(feature) {
			var color = feature.getProperty('FillColor');
			var strokeColor = feature.getProperty('Bcolor');
			var strokeOpacity = feature.getProperty('stroke-opacity');
			return {
				fillColor: color,
				strokeColor: strokeColor,
				strokeWeight: 1,
				fillOpacity: 0,
				strokeopacity: 0.7,
				content: 'AREA_1'
			};
		});
		this.map.data.addListener('click', showArrays);

		// show info window
		function showArrays(event) {
			closeLastOpenedInfoWindow();
			var position = { lat: event.latLng.lat(), lng: event.latLng.lng() };
			var content =
				'<div>' +
				'<h4 style="font-weight:bold;">Household and UCC Collection</h4><hr style="border-top:1px solid #afafaf;margin:5px;">' +
				'<div><div><p><strong>Bill Month: </strong>' +
				event.feature.getProperty('BILLMONTH') +
				'</p><p><strong>Vehicle No: </strong>' +
				event.feature.getProperty('VEHICLENO') +
				'</p>' +
				'<p><strong>Denomination : </strong>' +
				event.feature.getProperty('DENO') +
				'</p>' +
				'<p><strong>Collection Date: </strong>' +
				event.feature.getProperty('COLLECTIONDATE') +
				'</p>' +
				'<p><strong>Created By : </strong>' +
				event.feature.getProperty('CREATEDBY') +
				'</p>' +
				'</div></div>';
			infoWindow = new google.maps.InfoWindow({
				content: content,
				position: position
			});

			google.maps.InfoWindowOptions;
			var marker = new google.maps.Marker({
				position: position,
				map: this.map,
				zoom: 16,
				visible: false
			});
			infoWindow.open(this.map);
			lastOpenedInfoWindow = infoWindow;
		}

		function closeLastOpenedInfoWindow() {
			if (lastOpenedInfoWindow) {
				lastOpenedInfoWindow.close();
			}
		}
	}

	ngOnDestroy(){
        if (this.subscription){
            this.subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/maptracker/live-tracking/live-tracking.component.ts